import { Component, type ErrorInfo, type ReactNode } from "react";

type Props = { children: ReactNode };
type State = { hasError: boolean; message: string };

/**
 * Ловит падения React (в т.ч. failed dynamic import после деплоя),
 * чтобы не оставался пустой белый #root.
 */
export class AppErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, message: "" };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, message: error?.message || "Unknown error" };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("AppErrorBoundary", error, info.componentStack);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="min-h-[60vh] flex flex-col items-center justify-center gap-4 px-6 text-center bg-white text-slate-900">
        <h1 className="text-xl font-bold">Не удалось загрузить страницу</h1>
        <p className="text-sm text-slate-600 max-w-md">
          Часто это кэш после деплоя. Обновите страницу (Cmd+Shift+R / Ctrl+Shift+R).
        </p>
        <button
          type="button"
          className="rounded-lg bg-blue-600 px-5 py-2.5 text-sm font-semibold text-white hover:bg-blue-700"
          onClick={() => {
            const url = new URL(window.location.href);
            url.searchParams.set("_r", String(Date.now()));
            window.location.replace(url.toString());
          }}
        >
          Обновить
        </button>
      </div>
    );
  }
}
